/// <amd-module name="Artifacts/Cargo/commands/UpstreamOverride" />

import { CargoActions } from "Artifacts/Cargo/redux";
import { getUpstreamOverrideCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createUpstreamOverrideCommand = getUpstreamOverrideCommandCreator(
  CargoActions.setUpstreamOverride,
);
